


<nav class="navbar navbar-expand-lg ml-2 mainTop" >
    <!-- <a class="navbar-brand" href="{{oldDhruva}}"><img src="assets/img/newLogo.png" class="imgLogo"></a> -->
    <span class="navbar-brand"><img src="assets/img/newLogo.png" class="imgLogo"></span>
    <!-- <button class="btn btn-dark showToggle ml-auto" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="true" aria-label="Toggle navigation">
      <i class="fa fa-bars"></i>
  </button> -->
  
    <div class="navbar-collapse ml-4 " >
      <!-- <div class="iq-search-bar textFieldTop">
        <form action="#" class="searchbox">
           <input type="text" class="text search-input searchInner" placeholder="Type here to search...">
           <a class="search-link" href="#" >
            <i class="fa-solid fa-magnifying-glass" style="color:#000"></i></a>
        </form>
     </div> -->
     
      <div class="navRightGroup ml-auto">
        <ul class="navbar-nav topMenu">
          <li class="nav-item active" *ngIf="userRole === 'Administrator'">
            <img src="assets/img/UserListIcon.png" class="menuIcon"> <a class="nav-link" mat-menu-item [routerLink]="['/user']">User List</a>
          </li>
            <li class="nav-item" (click)="logout()">
              <img src="assets/img/LogoutIcon.png" class="menuIcon"> <span ></span><a class="nav-link" mat-menu-item >Logout</a>
              </li>
        </ul>

        <div class="topName">
          <img class="profileImg" src="assets/img/patient.png" />
          <div class="role">{{this.userDetails.firstName}}</div>
        </div>
      </div>

    </div>
  </nav>

  
<!-- <a [routerLink]="['/psychologists']" mat-menu-item>
    <mat-icon>dialpad</mat-icon>
    <span>Redial</span>
</a> -->